<div class="header">
  <div class="tabs">
    <button
      [class.is-active]="_activeTab === 'comment'"
      (click)="_onTabClick('comment')"
    >
      <sui-icon name="댓글"></sui-icon>
      <span>댓글</span>
    </button>
    <button
      [class.is-active]="_activeTab === 'underline'"
      (click)="_onTabClick('underline')"
    >
      <sui-icon name="밑줄"></sui-icon>
      <span>밑줄</span>
    </button>
  </div>
  <span class="group-select" *ngIf="!isMine" (click)="_onGroupSelectClick()">
    그룹책 멤버 선택하기
  </span>
</div>

<!-- 밑줄 -->
<div [hidden]="_activeTab !== 'underline'" class="content">
  <viewer-reading-group-records-underline
    [isMine]="isMine"
    [memberId]="memberId"
    [memberName]="memberName"
    [bid]="_bid"
    [isOwnedByUser]="_isOwnedByUser"
  ></viewer-reading-group-records-underline>
</div>

<!-- 댓글 -->
<div [hidden]="_activeTab !== 'comment'" class="content">
  <viewer-reading-group-records-comment
    [isMine]="isMine"
    [memberId]="memberId"
    [memberName]="memberName"
    [bid]="_bid"
    [isOwnedByUser]="_isOwnedByUser"
  ></viewer-reading-group-records-comment>
</div>
